<div class="registration-container">
  @if (!ready) {
    <div class="spinner-holder">
      <app-spinner></app-spinner>
    </div>
  }

  @if (ready) {
    <div>
      <div>
        <div class="my-profile">
          @if (giftBillingEnabled && isRegistered) {
            <a class="cart-icon" href="javascript:;" (click)="onCartClick()"><mat-icon>shopping_cart</mat-icon><span>{{cartStatus}}</span></a>
          }
          <mat-tab-group mat-stretch-tabs="false">
            <mat-tab label="My Account">
              @if (debugMode && showScenarios) {
                <div class="scenarios">
                  <div class="selector">
                    <mat-form-field appearance="outline">
                      <mat-label>Scenario</mat-label>
                      <mat-select [(ngModel)]="testScenarioId">
                        <mat-option [value]="-1">None</mat-option>
                        @for (scenario of testScenarios; track scenario; let i = $index) {
                          <mat-option [value]="i">
                            {{scenario.label}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="controls">
                    <a href="javascript:;" (click)="previousScenario()">Previous</a>
                    <div class="description spacer" [attr.title]="testScenario?.description">
                      @if (testScenario) {
                        {{testScenario.description}}
                      } @else {
                        Choose a test scenario above.
                      }
                    </div>
                    <a href="javascript:;" (click)="nextScenario()">Next</a>
                  </div>
                  @if (!testScenario) {
                    @if (capturedScenario) {
                      <tyt-json-view [json]="capturedScenario"></tyt-json-view>
                    } @else {
                      <a href="javascript:;" (click)="captureScenario()">Capture Scenario</a>
                    }
                  }
                  @if (testScenario) {
                    <br/>
                    <strong>NOTE ON SCENARIOS</strong><br/>
                    Scenarios are for display only. Attempting to take actions like Reactivate, Cancel etc will not respect the
                    scenario and will instead affect the logged in user.
                  }
                </div>
              }

              @if (entitledButNotEntitled) {
                <div class="entitled-not-entitled alert alert-success">
                  <mat-icon>check</mat-icon>
                  <div>
                    <strong>You are currently entitled to TYT membership content</strong><br/>
                    <p>The membership listed below may not be up to date, as that membership is not in good
                      standing, but our system indicates that <strong>you <u>are</u> able to access TYT membership content.</strong>
                      You should have no trouble doing so, but if you do (or you would like us to correct the
                      issue so that your current membership appears here) please contact TYT Support at
                      <a href="mailto:support@tytnetwork.com">support&#64;tytnetwork.com</a>.
                    </p>
                  </div>
                </div>
              }
              <div class="group membership-container">
                @if (membershipType) {
                  <div>
                    <div class="plan-box">
                      <div class="header">
                        <tyt-plus-tag />
                        Currently Selected Plan Benefits
                      </div>
                      <div class="content">
                        <div class="details">
                          @switch (membershipType) {
                            @case ('complimentary') {
                              <h4>Complimentary</h4>
                              Your TYT membership is free, compliments of TYT Network.
                              @if (membership.message) {
                                <div>
                                  A message from TYT:
                                  <blockquote>{{membership.message}}</blockquote>
                                </div>
                              }
                              @if (membership.renews_on) {
                                <div class="account-field">
                                  <label class="key">{{ isPastRenewal ? 'Expired on:' : 'Expires on:' }}</label>
                                  <time>{{ membership.renews_on | date: 'MM/dd/yyyy'}}</time>
                                </div>
                              }
                              <a routerLink="/join/membership">Sign up for a paid membership</a>
                            }
                            @case ('gift') {
                              <div>
                                @if (membership.status) {
                                  <span>{{ displayableMembershipStatus }}</span>
                                }
                              </div>
                              <!-- FIXED GIFT/SPONSORSHIP -->
                              @if (membership.gateway_name == 'free') {
                                @if (membership.gift_item.sponsorship) {
                                  Your membership was sponsored by another member.
                                }
                                @if (!membership.gift_item.sponsorship) {
                                  Your membership was a gift from {{membership.gift_item.purchaser_name}}.
                                }
                              }
                              <!-- RECURRING GIFT/SPONSORSHIP -->
                              @if (membership.gateway_name != 'free') {
                                @if (membership.gift_item.sponsorship) {
                                  @if (membership.cancelled_at && isPastRenewal) {
                                    <span>Your membership was sponsored by another member.</span>
                                  }
                                  <!-- cancelled and pastRenewal -->
                                  @if (membership.cancelled_at && !isPastRenewal) {
                                    <span>Your membership is a sponsored by another member.  It will end on {{membership.renews_on | date: 'fullDate'}}</span>
                                  }
                                  <!-- cancelled and not pastRenewal -->
                                  @if (!membership.cancelled_at) {
                                    <span>Your membership is sponsored by another member.</span>
                                  }
                                }
                                @if (!membership.gift_item.sponsorship) {
                                  @if (membership.cancelled_at && isPastRenewal) {
                                    <span>Your membership was a gift from {{membership.gift_item.purchaser_name}}.</span>
                                  }
                                  <!-- cancelled and pastRenewal -->
                                  @if (membership.cancelled_at && !isPastRenewal) {
                                    <span>Your membership is a gift from {{membership.gift_item.purchaser_name}}.  It will end on {{membership.renews_on | date: 'fullDate'}}</span>
                                  }
                                  <!-- cancelled and not pastRenewal -->
                                  @if (!membership.cancelled_at) {
                                    <span>Your membership is an ongoing gift from {{membership.gift_item.purchaser_name}}.</span>
                                  }
                                }
                              }
                              @if (membership.gift_item.gift_message) {
                                <blockquote style="font-style: oblique;">
                                  {{membership.gift_item.gift_message}}
                                  <br/>
                                  --{{membership.gift_item.purchaser_name}}
                                </blockquote>
                              }
                              <div class="account-field">
                                <div>
                                  <label class="key">Redeemed on: </label>
                                  <time>
                                    @if (membership.purchased_at || membership.created_at) {
                                      {{ (membership.purchased_at || membership.created_at) | date: 'MM/dd/yyyy'}}
                                    } @else {
                                      Unknown
                                    }
                                  </time>
                                </div>
                              </div>
                              @if (membership.gateway_name == 'free') {
                                <div class="account-field">
                                  <div>
                                    <label class="key">{{ isPastRenewal ? 'Expired on:' : 'Expires on:' }}</label>
                                    <time>{{ membership.renews_on | date: 'MM/dd/yyyy'}}</time>
                                  </div>
                                </div>
                              }
                              @if (membership.gateway_name != 'free') {
                                <div class="account-field">
                                  <div>
                                    @if (!membership.cancelled_at) {
                                      <label class="key">Renews on:</label>
                                    }
                                    @if (membership.cancelled_at) {
                                      <label class="key">{{ isPastRenewal ? 'Expired on:' : 'Expires on:' }}</label>
                                    }
                                    <time>{{ membership.renews_on | date: 'MM/dd/yyyy'}}</time>
                                  </div>
                                </div>
                              }
                              <br/>
                              @if (isPastRenewal && (membership.gateway_name == 'free' || !membership.active)) {
                                <div>
                                  To keep enjoying members-only content, <a routerLink="/join/membership">you can purchase a new membership</a>.
                                </div>
                              }
                              @if (!isPastRenewal && membership.gateway_name == 'free') {
                                <div>
                                  Ready to buy your own membership? <a routerLink="/join/membership">Click here!</a>
                                </div>
                              }
                            }
                            @case ('donation') {
                              You were granted <strong class="highlight">time-limited</strong> TYT membership via your
                              donation on {{membership.contribution.purchased_at | date : 'shortDate'}}
                              <div>
                                Want to set up a recurring membership? <a routerLink="/join/membership">Click here!</a>
                              </div>
                            }
                            @case ('standard') {
                              <div class="account-field">
                                <label class="key">Member Since:</label>
                                {{ (membership.member_since || membership.purchased_at || membership.created_at) | date: 'shortDate'}}
                              </div>
                              @if (isExpiring && !membership.refunded_at) {
                                <div class="account-field">
                                  <label class="key">{{ isPastRenewal ? 'Expired' : 'Expires' }} on:</label>
                                  <span class="danger-text"><time>{{ membership.renews_on | date: 'MM/dd/yyyy'}}</time></span>
                                </div>
                              }
                              @if (membership.cancelled_at && membership.refunded_at) {
                                <div class="account-field">
                                  <label class="key">Refunded on:</label>
                                  <span class="danger-text"><time>{{ membership.refunded_at | date: 'MM/dd/yyyy'}}</time></span>
                                </div>
                              }
                              @if (shouldShowRenewal && membership.status?.next_charge_amount) {
                                <div class="account-field">
                                  <label class="key">Next Charge:</label>
                                  <div>
                                    @if (membership.status?.next_charge_amount) {
                                      {{ membership.status.next_charge_amount / 100 | currency: 'USD'}} on
                                    }
                                    <time>{{ (membership.status.next_charge_date || membership.renews_on) | date: 'MM/dd/yyyy'}}</time>
                                  </div>
                                </div>
                              }
                              @if (membership.payment_source && !membership.contribution) {
                                <div class="account-field">
                                  <label class="key">Billing Method:</label>
                                  {{ membership.payment_source }}
                                </div>
                              }
                              @if (membership.introductory_periods) {
                                <div>
                                  <br/>
                                  Your membership has introductory pricing of {{(membership.introductory_price / 100) | currency: 'USD'}}{{perPeriod}}
                                  for the first {{membership.introductory_periods}} {{periods}}<br/>
                                  When your introductory period expires, you will be charged {{(membership.price / 100) | currency: 'USD'}}{{perPeriod}}
                                </div>
                              }
                              @if (!isExpiring) {
                                <div>
                                  @if (membership.payment_status === 'past_due') {
                                    <div>
                                      <br/>
                                      <mat-icon>error</mat-icon>
                                      <span class="danger-text">Your renewal payment was not successful.</span>
                                      Usually this is due to a problem with your payment information.
                                      Please <a [href]="billingUpdateUrl">update your billing information</a> now.
                                      Without a correction, you will lose access to membership benefits on <span class="danger-text">
                                    {{ membership.status.revocation_date | date:'MM/dd/yyyy'}}</span>.
                                  </div>
                                }
                              </div>
                            }
                            @if (membership.active && membership.cancelled_at) {
                              <div>
                                <br/>
                                Your membership is set to cancel as of <time>{{membership.cancelled_at | date:'MM/dd/yyyy'}}</time>.
                                You will not be charged again. Your access to membership benefits will end on
                                <time>{{membership.renews_on | date: 'MM/dd/yyyy'}}</time>.
                                @if (eligibleForReactivateMembership) {
                                  <br/><br/>
                                  You can still
                                  <a href="javascript:;" (click)="reactivateMembership()">reactivate</a>
                                  before your benefits expire!
                                }
                              </div>
                            }
                            @if (!membership.active || (isExpiring && membership.gateway_name == 'free')) {
                              <div>
                                @if (membership.cancelled_at) {
                                  <div>
                                    <br/>
                                    You canceled your membership on <time>{{membership.cancelled_at | date: 'MM/dd/yyyy'}}</time>.<br/>
                                    <a routerLink="/join/membership">Click here to sign up for a new TYT membership</a>
                                  </div>
                                }
                                @if (!membership.cancelled_at && !membership.gift_item && !membership.contribution) {
                                  <div>
                                    <br/>
                                    Your membership was canceled because we could not process your renewal payment.<br/>
                                    You can <a routerLink="/join/membership">restart your membership</a> at any time!
                                  </div>
                                }
                              </div>
                            }
                          }
                          @case ('missing_gms') {
                            <div class="alert alert-warning">
                              <strong>Contact Support</strong><br/>
                              It looks like there's an issue with your membership account. Please contact Member Services at <a href="mailto:support@tytnetwork.com">support&#64;tytnetwork.com</a>.
                              <br/>
                              Code: <code>missing_gms</code>
                            </div>
                          }
                          @case ('staff') {
                            <div class="no-membership">
                              You are TYT staff, so you are entitled to access all TYT content without a need for a membership.
                            </div>
                          }
                        }
                      </div>
                      @if (membership && membership.product) {
                        <div class="plan">
                          <h4>
                            {{membership.product.name}}
                            @if (membership.cancelled_at && !membership.refunded_at) {
                              <span class="canceled-tag">Canceled</span>
                            }
                            @if (!membership.active && !membership.cancelled_at) {
                              <span class="canceled-tag">Expired</span>
                            }
                            @if (membership.refunded_at) {
                              <span class="canceled-tag">Refunded</span>
                            }
                          </h4>
                          @if (membership.entitled) {
                            <div class="cms-content" [innerHTML]="membership.product.description | trustHtml" class="cms-content offer-benefits"></div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <br/>
                  <tyt-membership-features [product]="membership?.product" />
                  @if (whereToManageMembership === 'google_play') {
                    Your membership was purchased via the Google Play Store.
                    To change or cancel your membership, open the Google Play Store and navigate to Subscriptions.<br/><br/>
                  }
                  @if (whereToManageMembership === 'iap_apple') {
                    Your membership was purchased via the App Store on your iOS device. To change or cancel your membership,
                    open the App Store and navigate to Subscriptions.<br/><br/>
                  }
                  @if (whereToManageMembership === 'actblue') {
                    Your membership was purchased via ActBlue.
                    To change or cancel your membership, open ActBlue and navigate to Contributions -> Recurring'.<br/><br/>
                  }
                  @if (whereToManageMembership === 'youtube') {
                    Your membership was purchased via YouTube Channel Membership. To change or cancel your membership,
                    open the YouTube app or visit YouTube.com.<br/><br/>
                  }
                  @if (whereToManageMembership === 'tyt_com') {
                    You can change/cancel your membership by visiting TYT.com.<br/><br/>
                  }
                  @if (whereToManageMembership === 'here') {
                    @if (membershipBillingEnabled && eligibleForChangeMembership) {
                      <div class="membership-actions">
                        @if (membershipBillingEnabled) {
                          <a mat-button [href]="membershipChangeUrl" class="change-benefits">
                            Change My Benefits
                          </a>
                        }
                      </div>
                    }
                    <div class="membership-actions">
                      @if (shouldShowUpdateBillingOption) {
                        <a mat-button [href]="billingUpdateUrl">Update Billing Method</a>
                      }
                      @if (membershipBillingEnabled && eligibleForReactivateMembership) {
                        <a mat-raised-button color="primary" href="javascript:;" (click)="reactivateMembership()">Resume Membership</a>
                      }
                      @if (shouldShowCancelOption) {
                        <a mat-button
                        target="_blank" href="{{accountsUrl}}/membership/cancel">Cancel Membership</a>
                      }
                    </div>
                  }
                  @if (membershipBillingEnabled) {
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        Where is my membership?
                      </mat-expansion-panel-header>
                      <ng-container *ngTemplateOutlet="whereIsMyMembership"></ng-container>
                    </mat-expansion-panel>
                  }
                </div>
              } @else {
                @if (!isStaff) {
                  @if (!membership) {
                    <div>
                      <div class="no-membership">
                        You do not have a TYT membership.
                      </div>
                      <div class="membership-actions vertical">
                        <a routerLink="/join/membership" class="my-membership-button join-button">Join Plus</a>
                      </div>
                      @if (membershipBillingEnabled) {
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            Where is my membership?
                          </mat-expansion-panel-header>
                          <ng-container *ngTemplateOutlet="whereIsMyMembership"></ng-container>
                        </mat-expansion-panel>
                      }
                    </div>
                  }
                }
              }
              <br/>
            </div>

          </mat-tab>
          @if (giftBillingEnabled && isRegistered) {
            <mat-tab label="My Gift Accounts">
              @if (ready) {
                <div class="gift-view">
                  @if (giftItems.length) {
                    <div>
                      @for (giftItem of giftItems; track giftItem; let i = $index) {
                        <div class="gift-item">
                          <h5 class="gift-index">Gift {{i + 1}}</h5>
                          <h5 class="gift-name">{{giftItemName(giftItem)}}</h5>
                          <div>
                            <label class="key">Purchased:</label>
                            {{giftItem.created_at | date:'fullDate'}}
                          </div>
                          <div>
                            <label class="key">Sent to:</label>
                            {{ capitalizeFirstLetter(giftItem.recipient_name) }}
                          </div>
                          <div>
                            <label class="key">Emailed to:</label>
                            {{giftItem.recipient_email}}
                          </div>
                          <div>
                            <label class="key">From:</label>
                            {{giftItem.purchaser_name}}
                          </div>
                          <br/>
                          <div class="price-rate">
                            <p>{{giftPrice(giftItem) | currency:'USD'}}</p>
                            <p>{{giftRenewingStatus(giftItem)}}</p>
                          </div>
                          <div class="manage-gift">
                            @if (giftItem.recurring && giftItem.redeemed_at) {
                              <div>Next Renewal Date:&nbsp;
                                @if (giftItem.canceled_at) {
                                  <span>Canceled</span>
                                }
                                @if (!giftItem.canceled_at && giftItem.renewable_expired) {
                                  <span>Expired</span>
                                }
                                @if (!giftItem.canceled_at && !giftItem.renewable_expired) {
                                  <span>{{giftItem.renews_on | date:'longDate'}}</span>
                                }
                              </div>
                              @if (paymentSource) {
                                <p>Payment method: {{paymentSource.brand}} ***{{paymentSource.last4}} </p>
                              }
                              @if (giftItemPastDue(giftItem) || giftItem.renewable_expired) {
                                <p [ngStyle]="{'color': displayableGiftStatusColor(giftItem)}">
                                  @if (!giftItem.renewable_expired) {
                                    Renewal charge
                                    @if (paymentSource) {
                                      to {{paymentSource.brand}} ***{{paymentSource.last4}}
                                    }
                                    is past due
                                  }
                                  @if (giftItem.renewable_expired) {
                                    Expired at {{giftItem.renewable_expired_at | date:'longDate'}}
                                  }
                                </p>
                              }
                            }
                            @if (giftItem.recurring && !giftItem.canceled_at && !giftItem.renewable_expired) {
                              <a class="update-payment" [href]="billingUpdateUrl">Update Payment Method</a>
                              <a class="cancel-gift" href="javascript:;" (click)="cancelGiftMembership(giftItem)">Cancel this gift membership</a>
                            }
                          </div>
                          <br/>
                          @if (giftItem.gift_message) {
                            <div style="font-style: oblique;">
                              Gift Message
                              <blockquote>{{giftItem.gift_message}}</blockquote>
                            </div>
                          }
                          <br/>
                          <div>
                            <label class="key">Redeemed on:</label>
                            {{ giftItem.redeemed_at ? (giftItem.redeemed_at | date: 'fullDate') : 'Not redeemed'}}&nbsp;
                            @if (!giftItem.redeemed_at && giftItem.canceled_at) {
                              <span>-&nbsp;Canceled</span>
                            }
                          </div>
                          <div>
                            <label class="key"></label>
                            @if (!giftItem.redeemed_at) {
                              <a (click)="sendReminder(giftItem)" href="javascript:;">Resend Gift Message</a>
                            }
                          </div>
                          <hr/>
                        </div>
                      }
                    </div>
                  }
                  @if (giftItems.length === 0) {
                    <div class="none-purchased">None purchased</div>
                  }
                  <div class="actions">
                    @if (giftBillingEnabled) {
                      <a mat-raised-button color="primary" class="route-links"
                        href="{{accountsUrl}}/gift">
                        Purchase {{ giftItems.length ? 'additional' : '' }} gift memberships
                      </a>
                    }
                  </div>
                  <br/>
                  <a class="route-links" url="https://help.tyt.com/category/55-gift-memberships" target="_blank">Learn More</a>
                </div>
              }
            </mat-tab>
          }
          @if (giftBillingEnabled && isRegistered) {
            <mat-tab label="My Gift Membership Packages">
              @if (ready) {
                <div class="sponsorship-view">
                  <div class="title">
                    <h4>Gift Membership Packages</h4>
                  </div>
                  @if (sponsorshipItems.length) {
                    <div class="sponsorships">
                      @for (sponsorshipItem of sponsorshipItems; track sponsorshipItem; let i = $index) {
                        <div class="sponsorship-item">
                          @if (sponsorshipItem.sponsorship_product_id) {
                            <h5>Amplify</h5>
                          }
                          <h5 class="gift-name">{{giftItemName(sponsorshipItem)}}</h5>
                          <div>
                            <label class="key">Purchased:</label>
                            {{sponsorshipItem.created_at | date:'fullDate'}}
                          </div>
                          @if (!sponsorshipItem.sponsorship_product_id) {
                            <div>
                              <label class="key">Redemption URL:</label>
                              {{sponsorshipItem.redemption_url}}
                            </div>
                          }
                          @if (!sponsorshipItem.sponsorship_product_id) {
                            <div>
                              <label class="key">Redemption Code:</label>
                              {{sponsorshipItem.code}}
                            </div>
                          }
                          <div>
                            <label class="key">Quantity:</label>
                            {{sponsorshipItem.canceled_at ? 'Canceled' : sponsorshipItem.purchased_quantity}}
                          </div>
                          @if (!sponsorshipItem.sponsorship_product_id) {
                            <div>
                              <label class="key">Redeemed:</label>
                              {{sponsorshipItem.redemptions_count || 0}} &nbsp;
                              @if (sponsorshipItem.redemptions_count) {
                                <a *ngIf="sponsorshipItem.redemptions_count" target="_blank" [href]="getViewSponsorshipRedemptionUrl(sponsorshipItem, i + 1)">View</a>
                              }
                            </div>
                          }
                          @if (sponsorshipItem.recurring && !sponsorshipItem.canceled_at) {
                            <a mat-button href="javascript:;" (click)="cancelGiftMembership(sponsorshipItem)">Cancel this package</a>
                          }
                          <hr/>
                        </div>
                      }
                    </div>
                  }
                  @if (sponsorshipItems.length) {
                    <div>
                      <a routerLink="/resources/gift-membership-packages/toolkit" target="_blank" class="route-links sponsorship-toolkit">Package Toolkit</a>
                    </div>
                  }
                  @if (sponsorshipItems.length === 0) {
                    <p>Gift Membership Packages are a way for you to purchase TYT memberships in bulk and distribute them to whomever you want, whenever you want. &nbsp; <a url="https://help.tyt.com/category/55-gift-memberships" target="_blank">Learn more</a></p>
                    <div class="none-purchased">None purchased</div>
                  }
                  <div class="actions">
                    @if (giftBillingEnabled) {
                      <a mat-raised-button color="primary" class="route-links"
                        href="{{accountsUrl}}/sponsorship">
                        {{ sponsorshipItems.length ? 'Purchase additional' : 'Buy' }} packages
                      </a>
                    }
                  </div>
                  <br/>
                </div>
              }
            </mat-tab>
          }
        </mat-tab-group>
        <app-notice></app-notice>
        @if (updateSuccessMessage) {
          <div class="alert alert-success">
            {{updateSuccessMessage}}
          </div>
        }
        @if (updateErrorMessage) {
          <div class="alert alert-danger">
            {{updateErrorMessage}}
          </div>
        }
      </div>
    </div>
    @if (debugMode) {
      <div>
        <hr/>
        <div class="debug-toggle">
          @if (!showScenarios) {
            <a href="javascript:;" (click)="showScenarios = true">Show Scenarios</a>
          }
          @if (showScenarios) {
            <a href="javascript:;" (click)="showScenarios = false">Hide Scenarios</a>
          }
          |
          @if (!showDebugger) {
            <a href="javascript:;" (click)="showDebugger = true">Show Debugger</a>
          }
          @if (showDebugger) {
            <a href="javascript:;" (click)="showDebugger = false">Hide Debugger</a>
          }
        </div>
        @if (showDebugger) {
          <div class="debugger alert alert-warning" style="text-align: left;">
            <strong>STATE FLAGS</strong><br/>
            <div>
              <label class="key">membershipType</label>
              {{membershipType}}
            </div>
            <div>
              <label class="key">isPastRenewal</label>
              {{isPastRenewal}}
            </div>
            <div>
              <label class="key">shouldShowCancelOption</label>
              {{shouldShowCancelOption}}
            </div>
            <div>
              <label class="key">shouldShowPastDueNotice</label>
              {{shouldShowPastDueNotice}}
            </div>
            <div>
              <label class="key">shouldShowRenewal</label>
              {{shouldShowRenewal}}
            </div>
            <hr/>
            <tyt-json-view [value]="user"></tyt-json-view>
          </div>
        }
      </div>
    }
  </div>
}
</div>

<ng-template #whereIsMyMembership>
  @if (!user) {
    <p>You are not currently signed in to a TYT account.</p>
  }
  @if (user) {
    <p>
      You are currently logged into the TYT account with email address <strong>{{user.email}}</strong> which
      was created <strong>{{user.created_at | date: 'shortDate'}}</strong>. If you currently have a
      membership but do not see it here, it is possible that your membership is under another account
      with another email address. If this is the case, log out using the gear menu in the upper right and
      log into the other account.
    </p>
  }

  <p>
    If you purchased your membership via <strong>Google Play</strong> or
    <strong>Apple In-App-Purchase</strong>, it is possible you did not log into your existing TYT account
    prior to purchasing. Since Apple and Google do not allow us to access your email address automatically,
    this means your membership is either not associated with a TYT account or it is associated with a
    different account if you registered an account within the app.
  </p>
  <p>
    To resolve this you will need to use the Login option from within the app to log in to this account
    (your membership will be automatically moved to this account in that case), or if you already
    created an account on the app, use the Login With Another Account option to request that your accounts
    be merged.
  </p>
  <p>If you have any questions, please feel free to email us at support&#64;tytnetwork.com.</p>
</ng-template>
